import React, { useCallback, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  InputAdornment,
  Stack,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import { useStyles } from "./styles";
import StudentActive from "../../../assets/images/attendance/studentActive.png";
import StaffActive from "../../../assets/images/attendance/staffActive.png";
import student from "../../../assets/images/attendance/student.png";
import staff from "../../../assets/images/attendance/staff.png";
import useAttendance from "../../../Hooks/attendance";
import useCourse from "../../../Hooks/course";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import CustomPagination from "../../../common/Pagination";
import usePagination from "../../../common/usePagination";
import useAuthStore from "../../../Hooks/auth";
import { useNavigate } from "react-router-dom";

const columns = [
  {
    id: "name",
    label: "Name",
    align: "center",
    sortby: true,
  },
  {
    id: "attendanceDate",
    label: "Date",
    align: "center",
    sortby: true,
  },
  {
    id: "forenoon",
    label: "Fore Noon",
    align: "center",
    sortby: true,
  },
  {
    id: "afternoon",
    label: "After Noon",
    align: "center",
    sortby: true,
  },
];

const studentColumns = [
  {
    id: "s.no",
    label: "S.No",
    align: "center",
    sortby: true,
    size: "small",
  },
  {
    id: "firstname",
    label: "Student Name",
    align: "center",
    sortby: true,
  },
  {
    id: "attendanceDate",
    label: "Date",
    align: "center",
    sortby: true,
  },
  {
    id: "forenoon",
    label: "Fore Noon",
    align: "center",
    sortby: true,
  },
  {
    id: "afternoon",
    label: "After Noon",
    align: "center",
    sortby: true,
  },
];
const studentAttendanceSchema = Yup.object().shape({
  fromDate: Yup.string().required("* Please fill start date"),
  toDate: Yup.string().required("* Please fill end date"),
  regNumber: Yup.string().required("* Please enter registration number"),
});

const AttendanceManagement = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    studentAttendance,
    staffAttendance,
    studentAttendancePercentage,
    getStudentAttendanceDetailsAction,
    getStaffAttendanceDetailsAction,
    getAttendancePercentageAction,
    resetStudentAtttendanceAction,
    resetStaffAtttendanceAction,
    clearStudentAttendancePercentageAction,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,
  } = useAttendance();
  const formRef = React.useRef();

  const { getDepartmentAction } = useCourse();
  const [activeTab, setActiveTab] = useState("attendance2");
  // const [page, setPage] = useState(1);
  // const [PerPage, setPerPage] = useState(10);
  // const [offset, setOffset] = useState(0);
  // const [regNo, setRegNo] = useState();
  // const [fromDateAttendance, setFromDateAttendance]= useState();
  // const [toDateAttendance, setTodateAttendance] = useState();
  const { institutionId } = useAuthStore();

  const handlePage = (e) => {
    // setPerPage(e.target.value);
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
    setTimeout(() => {
      formRef?.current?.handleSubmit();
    }, 100);
  };

  React.useEffect(() => {
    resetStudentAtttendanceAction();
    resetStaffAtttendanceAction();
    return () => {
      clearStudentAttendancePercentageAction();
    };
  }, []);

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  const initStudentAttendance = {
    fromDate: "",
    toDate: "",
    regNumber: "",
    limit: "",
    offset: "",
  };

  const count =
    staffAttendance &&
    Math.ceil(staffAttendance?.[0]?.totalNoOfRecords / perPage);
  const _DATA = usePagination(staffAttendance, perPage);
  console.log(
    "studentAttendance?.searchStudentAttendance",
    studentAttendance?.searchStudentAttendance
  );
  const studentCount =
    studentAttendance?.searchStudentAttendance &&
    Math.ceil(studentAttendance?.totalNo?.totalNoOfRecords / perPage);
  const _DATAStudent = usePagination(
    studentAttendance?.searchStudentAttendance,
    perPage
  );

  const handleChange = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * PerPage - PerPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      // _DATA.jump(p);
    },
    [perPage, page]
  );

  const handleChangeStudent = useCallback(
    (e, p) => {
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      // _DATAStudent.jump(p);
      setTimeout(() => {
        formRef?.current?.handleSubmit();
      }, 100);
    },
    [perPage, page]
  );
  console.log("studentCount", studentCount, page, perPage);
  return (
    <Grid container className={classes.attendance}>
      <Grid item lg={10} sm={12}>
        <Stack sx={{ flexDirection: "column" }}>
          <Stack
            sx={{
              flexDirection: "row",
              my: 2,
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* <img
            src={activeTab === "attendance1" ? StaffActive : staff}
            className={classes.imggap}
            alt="attendance1"
            role={"button"}
            style={{ cursor: "pointer" }}
            onClick={(e) => setActiveTab(e.target.alt)}
            draggable="false"
          /> */}
            <img
              src={StudentActive}
              className={classes.imggap}
              alt="attendance2"
              role={"button"}
              style={{ cursor: "pointer" }}
              onClick={(e) => setActiveTab(e.target.alt)}
              draggable="false"
            />
            <Button
              onClick={() => {
                navigate("/attendanceManagement/report");
              }}
              className={classes.report_page_btn}
            >
              Reports
            </Button>
          </Stack>
        </Stack>
      </Grid>

      <>
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            display: "flex",
            my: 2,
            gap: 2,
          }}
        >
          <Formik
            initialValues={initStudentAttendance}
            validationSchema={studentAttendanceSchema}
            validateOnBlur={false}
            validateOnChange={false}
            enableReinitialize
            innerRef={formRef}
            onSubmit={(values) => {
              if (activeTab === "attendance1") {
                getStudentAttendanceDetailsAction({
                  ...values,
                  limit: perPage,
                  offset: offset,
                  institutionId,
                });
                getAttendancePercentageAction({
                  ...values,
                  regNumber: values.regNumber,
                  fromDate: values.fromDate,
                  toDate: values.toDate,
                });
              } else {
                getStudentAttendanceDetailsAction({
                  ...values,
                  limit: perPage,
                  offset: offset,
                  institutionId,
                });
                getAttendancePercentageAction({
                  ...values,
                  limit: perPage,
                  offset: offset,
                  institutionId,
                });
              }
            }}
          >
            {(formik) => {
              const { errors, touched, handleChange, handleSubmit, values } =
                formik;
              return (
                <>
                  <form
                    onSubmit={handleSubmit}
                    className={classes.attendanceForm}
                  >
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        display: "flex",
                        gap: 2,
                      }}
                    >
                      <Typography className={classes.textgap}>
                        {activeTab === "attendance1"
                          ? "Student ID"
                          : "Student ID"}
                      </Typography>
                      <Stack>
                        <TextField
                          sx={{
                            width: "180px",
                          }}
                          id="regNumber"
                          name="regNumber"
                          placeholder={
                            activeTab === "attendance1"
                              ? "Search Student"
                              : "Search Student"
                          }
                          type={"text"}
                          className={
                            errors.firstName && touched.firstName
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onKeyDown={(e) => {
                            // if (activeTab === "attendance1") {
                            //   getStaffAttendanceDetailsAction({
                            //     ...values,
                            //     limit: 4,
                            //     offset: 0,
                            //   });
                            // } else {
                            //   getStudentAttendanceDetailsAction({
                            //     ...values,
                            //     limit: 4,
                            //     offset: 0,
                            //   });
                            //   getAttendancePercentageAction({
                            //     ...values,
                            //     regNumber: values.regNumber,
                            //     fromDate: values.fromDate,
                            //     toDate: values.toDate,
                            //   });
                            // }
                          }}
                          value={values.regNumber}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                position="start"
                                sx={{ cursor: "pointer" }}
                              >
                                <SearchIcon
                                  role="button"
                                  onClick={() => {
                                    if (activeTab === "attendance1") {
                                      getStaffAttendanceDetailsAction({
                                        ...values,
                                        limit: 4,
                                        offset: 0,
                                      });
                                    } else {
                                      getStudentAttendanceDetailsAction({
                                        ...values,
                                        limit: 4,
                                        offset: 0,
                                      });
                                      getAttendancePercentageAction({
                                        ...values,
                                        regNumber: values.regNumber,
                                        fromDate: values.fromDate,
                                        toDate: values.toDate,
                                      });
                                    }
                                  }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                        <ErrorMessage
                          name="regNumber"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        display: "flex",
                        gap: 2,
                      }}
                    >
                      <Typography className={classes.textgap}>
                        Date From
                      </Typography>
                      <Stack>
                        <TextField
                          id="fromDate"
                          type="date"
                          name="fromDate"
                          sx={{
                            width: "180px",
                          }}
                          value={values.fromDate}
                          onChange={handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          placeholder="Enter Date From"
                        />
                        <ErrorMessage
                          name="fromDate"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        display: "flex",
                        gap: 2,
                      }}
                    >
                      <Typography className={classes.textgap}>
                        Date To
                      </Typography>
                      <Stack>
                        <TextField
                          id="toDate"
                          type="date"
                          name="toDate"
                          sx={{
                            width: "180px",
                          }}
                          value={values.toDate}
                          onChange={handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          placeholder="Enter Date To"
                        />
                        <ErrorMessage
                          name="toDate"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack>
                      <Button
                        type="submit"
                        sx={{
                          px: 4,
                          py: 1,
                          borderRadius: "50px",
                          minWidth: "150px",
                        }}
                        className={classes.search_btn}
                      >
                        Search
                      </Button>
                    </Stack>
                  </form>
                </>
              );
            }}
          </Formik>
        </Stack>
      </>

      <Grid item lg={10} sm={12}>
        <Stack sx={{ my: 4 }}>
          <Box sx={{ width: "100%" }}>
            <Paper
              sx={{
                width: "100%",
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
            >
              <Stack
                sx={{
                  padding: "12px 32px",
                }}
              >
                {studentAttendancePercentage &&
                studentAttendancePercentage > 0 ? (
                  <>
                    <Stack style={{ textAlign: "center" }}>
                      <Typography className={classes.student_attendance_text}>
                        Attendance Percentage :
                        <span
                          className={classes.student_attendance_percentage_text}
                        >
                          {studentAttendancePercentage.toFixed(2)}%
                        </span>
                      </Typography>
                    </Stack>
                  </>
                ) : (
                  <></>
                )}
                <TableContainer sx={{ maxHeight: "440px" }}>
                  <Table
                    aria-label="sticky table"
                    className={classes.root}
                    style={{ padding: 0 }}
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow classes={{ root: classes.thead }}>
                        {/* {activeTab === "attendance1" ? (
                          <>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </>
                        ) : (
                          <>
                            {studentColumns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </>
                        )} */}
                        <>
                          {studentColumns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                                paddingLeft: column.paddingLeft,
                              }}
                              classes={{ root: classes.columnData }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </>
                      </TableRow>
                    </TableHead>

                    <TableBody classes={{ root: classes.tBody }}>
                      {/* {activeTab === "attendance1" ? (
                        <>
                          {staffAttendance && staffAttendance?.length > 0 ? (
                            _DATA.currentData()?.map((_el, index) => (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                              >
                                {columns.map((column) => {
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "s.no" ? (
                                        <span>{index + 1}</span>
                                      ) : column.id === "name" ? (
                                        _el.name
                                      ) : column.id === "attendanceDate" ? (
                                        _el.attendanceDate
                                      ) : column.id === "forenoon" ? (
                                        Boolean(Number(_el.forenoon)) == "1" ? (
                                          "Present"
                                        ) : (
                                          "Absent"
                                        )
                                      ) : column.id === "afternoon" ? (
                                        Boolean(Number(_el.afternoon)) ==
                                        "1" ? (
                                          "Present"
                                        ) : (
                                          "Absent"
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={columns.length}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data Available
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      ) : (
                        <>
                          {studentAttendance &&
                          studentAttendance?.studentAttendance?.length > 0 ? (
                            _DATAStudent.currentData()?.map((_el, index) => (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                              >
                                {studentColumns.map((column) => {
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "s.no" ? (
                                        <span>{index + 1}</span>
                                      ) : column.id === "firstname" ? (
                                        _el.firstname
                                      ) : column.id === "attendanceDate" ? (
                                        _el.attendanceDate
                                      ) : column.id === "forenoon" ? (
                                        Boolean(Number(_el.forenoon)) == "1" ? (
                                          "Present"
                                        ) : (
                                          "Absent"
                                        )
                                      ) : column.id === "afternoon" ? (
                                        Boolean(Number(_el.afternoon)) ==
                                        "1" ? (
                                          "Present"
                                        ) : (
                                          "Absent"
                                        )
                                      ) : column.id === "edit" ? (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          // onClick={editList}
                                        >
                                          <img src={Pen} alt="pen" />
                                        </Stack>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={studentColumns.length}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data Available
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      )} */}
                      <>
                        {studentAttendance?.searchStudentAttendance &&
                        studentAttendance?.searchStudentAttendance?.length >
                          0 ? (
                          _DATAStudent.currentData()?.map((_el, index) => (
                            <TableRow role="checkbox" tabIndex={-1} key={index}>
                              {studentColumns.map((column) => {
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    lineHeight={0}
                                  >
                                    {column.id === "s.no" ? (
                                      <span>{offset + index + 1}</span>
                                    ) : column.id === "firstname" ? (
                                      _el.firstname
                                    ) : column.id === "attendanceDate" ? (
                                      _el.attendanceDate
                                    ) : column.id === "forenoon" ? (
                                      Boolean(Number(_el.forenoon)) == "1" ? (
                                        //   "Present"
                                        // ) : (
                                        //   "Absent"

                                        <Grid
                                          display="flex"
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          {" "}
                                          <p
                                            style={{
                                              color: "green",
                                              paddingRight: "20px",
                                            }}
                                          >
                                            Present
                                          </p>
                                          {/* <p style={{ color: "black" }}>
                                          Absent
                                        </p> */}{" "}
                                        </Grid>
                                      ) : (
                                        <Grid
                                          display="flex"
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          {" "}
                                          <p
                                            style={{
                                              color: "red",
                                              paddingRight: "20px",
                                            }}
                                          >
                                            Absent
                                          </p>
                                          {/* <p style={{ color: "red" }}>
                                          Absent
                                        </p> */}{" "}
                                        </Grid>
                                      )
                                    ) : column.id === "afternoon" ? (
                                      Boolean(Number(_el.afternoon)) == "1" ? (
                                        //   "Present"
                                        // ) : (
                                        //   "Absent"
                                        <Grid
                                          display="flex"
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          {" "}
                                          <p
                                            style={{
                                              color: "green",
                                              paddingRight: "20px",
                                            }}
                                          >
                                            Present
                                          </p>
                                          {/* <p style={{ color: "black" }}>
                                          Absent
                                        </p> */}{" "}
                                        </Grid>
                                      ) : (
                                        <Grid
                                          display="flex"
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          {" "}
                                          <p
                                            style={{
                                              color: "red",
                                              paddingRight: "20px",
                                            }}
                                          >
                                            Absent
                                          </p>
                                          {/* <p style={{ color: "red" }}>
                                          Absent
                                        </p> */}{" "}
                                        </Grid>
                                      )
                                    ) : column.id === "edit" ? (
                                      <Stack
                                        sx={{
                                          alignItems: "center",
                                          cursor: "pointer",
                                        }}
                                        // onClick={editList}
                                      >
                                        <img src={Pen} alt="pen" />
                                      </Stack>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={studentColumns.length}
                              sx={{ borderBottom: "none" }}
                            >
                              <Stack
                                sx={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                No Data Available
                              </Stack>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    </TableBody>
                  </Table>
                </TableContainer>
                {/* {staffAttendance?.length > 0 && activeTab === "attendance1" && (
                  <CustomPagination
                    count={count}
                    page={page}
                    onPageChange={handleChange}
                    handlePage={handlePage}
                    perPage={PerPage}
                  />
                )} */}

                {studentAttendance?.totalNo?.totalNoOfRecords > 10 &&
                  activeTab === "attendance2" && (
                    <CustomPagination
                      count={studentCount}
                      page={page}
                      onPageChange={handleChangeStudent}
                      handlePage={handlePage}
                      perPage={perPage}
                    />
                  )}
              </Stack>
            </Paper>
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default AttendanceManagement;
